import React from 'react';

// Pied de page d'impression : invisible à l'écran.
// La pagination "Page X / Y" est gérée nativement via @page CSS counter(page).
const PrintFooter = ({ note }) => (
    <div className="print-only" style={{
        display: 'none',
        marginTop: 24,
        paddingTop: 8,
        borderTop: '1px solid #ddd',
        textAlign: 'center',
        fontSize: 10,
        color: '#8c8c8c',
    }}>
        {note || 'Document confidentiel — CAP Assurances. Reproduction interdite sans autorisation.'}
    </div>
);

export default PrintFooter;
